// @flow

import React from 'react';
import EmbeddedUrlPage from './embeddedurl/EmbeddedUrlPage';
import { embeddedUrlPage } from '../../../const';

function GroupOverviewEmbeddedUrl() {
  return (
    <EmbeddedUrlPage
      pageName={embeddedUrlPage.group}
      cssClass="group-overview"
    />
  );
}

export default GroupOverviewEmbeddedUrl;
